import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import Navbar from './components/Navbar';

import Landing from './pages/Landing';
import Register from './pages/Register';
import Login from './pages/Login';
import EmailVerification from './pages/EmailVerification';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import PostRide from './pages/PostRide';
import BrowseRides from './pages/BrowseRides';
import RideDetail from './pages/RideDetail';
import MyRides from './pages/MyRides';
import { MessagesList, ChatWindow } from './pages/Messages';

function RequireAuth({ children }) {
  const { currentUser } = useApp();
  if (!currentUser) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { currentUser } = useApp();
  if (currentUser) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const { currentUser } = useApp();

  return (
    <>
      <Routes>
        {/* Public */}
        <Route path="/" element={
          <PublicOnly><Landing /></PublicOnly>
        } />
        <Route path="/register" element={
          <PublicOnly><Register /></PublicOnly>
        } />
        <Route path="/login" element={
          <PublicOnly><Login /></PublicOnly>
        } />
        <Route path="/verify-email" element={<EmailVerification />} />

        {/* Protected */}
        <Route path="/dashboard" element={
          <RequireAuth><Dashboard /></RequireAuth>
        } />
        <Route path="/profile/:id" element={
          <RequireAuth><Profile /></RequireAuth>
        } />
        <Route path="/edit-profile" element={
          <RequireAuth><EditProfile /></RequireAuth>
        } />
        <Route path="/post-ride" element={
          <RequireAuth><PostRide /></RequireAuth>
        } />
        <Route path="/browse" element={
          <RequireAuth><BrowseRides /></RequireAuth>
        } />
        <Route path="/ride/:id" element={
          <RequireAuth><RideDetail /></RequireAuth>
        } />
        <Route path="/my-rides" element={
          <RequireAuth><MyRides /></RequireAuth>
        } />
        <Route path="/messages" element={
          <RequireAuth><MessagesList /></RequireAuth>
        } />
        <Route path="/messages/:id" element={
          <RequireAuth><ChatWindow /></RequireAuth>
        } />

        {/* Fallback */}
        <Route path="*" element={
          <Navigate to={currentUser ? '/dashboard' : '/'} replace />
        } />
      </Routes>

      {currentUser && <Navbar />}
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}
